import { render, staticRenderFns } from "./desktop-menu.vue?vue&type=template&id=8b1bd8a0&scoped=true&"
import script from "./desktop-menu.vue?vue&type=script&lang=js&"
export * from "./desktop-menu.vue?vue&type=script&lang=js&"
import style0 from "./desktop-menu.vue?vue&type=style&index=0&id=8b1bd8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1bd8a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VListItemTitle,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
